/**
 * Created by Ivan on 11.10.2024
 */

StickersRewardWindow.prototype.createReceiveAnimation = function () {
    let unreceivedStickersAmount = this.stickersViews.length;
    const moveDuration = 0.3;
    const stickerReceiveDelay = 0.4;
    const additionalDelay = this.stickersViews.some((sticker) => sticker.stickerView.sticker.duplicate) ? 1.8 : 0;

    return new cc.Spawn(
        new cc.CallFunc(() => {
            this.stickersViews.forEach((sticker, index) => {
                const stickerAnimation = sticker.createAnimation();

                sticker.stickerView.setVisible(false);

                const openDelayTime = sticker.stickerView.sticker.isRare() ? 1 : 0;
                const actions = [
                    new cc.DelayTime(index * stickerReceiveDelay),
                    new cc.Hide(),
                    new cc.CallFunc(() => {
                        stickerAnimation.setAnimation(0, "idle_silver", true);
                    }),

                    new cc.CallFunc(() => {
                        if (sticker.stickerView.sticker.isRare()) {
                            stickerAnimation.setAnimation(0, "idle_gold", true);
                            cleverapps.effects.fire("stickers.window.gold.light");
                        }
                    }),
                    new cc.CallFunc(() => {
                        this.stickersSource.updateStickersAmount(--unreceivedStickersAmount);
                        sticker.setVisible(true);
                        const targetPosition = sticker.getPosition();
                        sticker.targetPosition = targetPosition;

                        const worldStartPos = this.stickersSource.getParent().convertToWorldSpace(this.stickersSource.getPosition());
                        const localStartPos = sticker.getParent().convertToNodeSpace(worldStartPos);

                        sticker.setPosition(localStartPos);
                        sticker.setScale(0.5);

                        sticker.runAction(
                            new cc.Spawn(
                                new cc.MoveTo(moveDuration, targetPosition).easing(cc.easeSineInOut()),
                                new cc.ScaleTo(moveDuration, 1).easing(cc.easeBackOut())
                            )
                        );
                    }),
                    new cc.DelayTime(moveDuration),
                    new cc.Spawn(
                        new cc.Sequence(
                            new cc.DelayTime(0.5),
                            new cc.CallFunc(() => {
                                sticker.stickerView.setVisible(true);
                            })
                        ),
                        new cc.DelayTime(openDelayTime),
                        new cc.CallFunc(() => {
                            let animation, effect;
                            if (sticker.stickerView.sticker.isRare()) {
                                animation = "open_gold";
                                effect = "stickers.window.gold.open";
                            } else {
                                animation = "open_silver";
                                effect = "stickers.window.silver.open";
                            }

                            cleverapps.effects.fire(effect);
                            stickerAnimation.setAnimation(0, animation, false);
                            stickerAnimation.setCompleteListenerRemove();
                        })
                    ),
                    new cc.DelayTime(1 - openDelayTime)
                ];

                if (sticker.stickerView.sticker.duplicate) {
                    actions.push(sticker.stickerView.changeStickerToJoker(1));
                } else {
                    actions.push(new cc.Spawn(
                        new cc.CallFunc(
                            (() => {
                                sticker.stickerView.badge.runAction(
                                    new cc.Sequence(
                                        new cc.DelayTime(0.5),
                                        new cc.CallFunc(() => {
                                            cleverapps.effects.fire("stickers.window.new");
                                        }),
                                        new cc.Show(),
                                        new cc.ScaleTo(0.4, 1).easing(cc.easeBackOut())
                                    )
                                );
                            }),
                            new cc.DelayTime(1.9)
                        )
                    ));
                }

                if (index === this.stickersViews.length - 1) {
                    actions.push(
                        new cc.CallFunc(() => {
                            this.stickersSource.runAction(this.stickersSource.createHideAction());
                        })
                    );
                }

                sticker.runAction(new cc.Sequence(actions));
            });
        }),
        new cc.DelayTime(this.stickersViews.length * stickerReceiveDelay + 0.5 + additionalDelay)
    );
};

RewardStickerView.prototype._finishReceiveAnimation = RewardStickerView.prototype.finishReceiveAnimation;
RewardStickerView.prototype.finishReceiveAnimation = function () {
    this._finishReceiveAnimation.call(this);
    if (this.stickerView.sticker.duplicate) {
        if (this.duplicateLabel) {
            this.duplicateLabel.setVisible(false);
        }
        this.stickerView.changeStickerToJoker(0, true);
    }
};

StickersPackView.prototype.onTouchInShadow = function () {
    this.runAction(this.createOpenAction());
};

StickersPackView.prototype.createShowAction = function () {
    return new cc.Sequence(
        new cc.Show(),
        new cc.Spawn(
            new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut()),
            new cc.FadeIn(0.5)
        )
    );
};

StickersPackView.prototype.createOpenAction = function () {
    return new cc.MoveTo(0.5, this.positionFromAlignment(cleverapps.styles.StickersRewardWindow.source)).easing(cc.easeSineInOut());
};

StickersPackView.prototype.createHideAction = function () {
    return new cc.Sequence(
        new cc.Spawn(
            new cc.ScaleTo(0.5, 0.6).easing(cc.easeBackIn()),
            new cc.FadeOut(0.5)
        ),
        new cc.RemoveSelf()
    );
};

StickersPackView.prototype.showAnimation = function (callback) {
    callback = callback || function () {};

    this.runAction(new cc.Sequence(
        this.createShowAction(),
        new cc.DelayTime(0.3),
        this.createOpenAction(),
        new cc.CallFunc(callback)
    ));
};